<template>
  <div class="loading-container">正在处理登录...</div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import { showToast } from 'vant';
import router from '@/router'
import authApi from '@/utils/api/auth'
const route = useRoute();

onMounted(async () => {
  const code = route.query.code;

  if (!code) {
    showToast({
      message: "未获取到授权 code",
      duration: 2000,
    });
    return;
  }

  try {
    // 发送给后端
    const res = await authApi.getWeComUserInfo(code);
    console.log("企业微信用户信息：", res.data);
    const {  userid,mobile,gender,name,avatar,token,shop_clerk_uuid } = res.data;
    localStorage.setItem("userInfo", JSON.stringify({ userid,mobile,gender,name,avatar }));
    localStorage.setItem("token", token);
    localStorage.setItem("shop_clerk_uuid", shop_clerk_uuid);
    // 跳转首页
    router.replace({ path: "/workbench" });
  } catch (err) {
    console.error("授权失败", err);
    showToast({
      message: "登录失败，请重试" + err.message,
      duration: 2000,
    });
  }
});
</script>

<style lang="less" scoped>
.loading-container {
    text-align: center;
    padding: 20px;
    font-size: 20px;
    font-weight: 500;
    color: #654317;
    font-family: 'PingFang SC-Semibold';
}
</style>